import { useEffect, useState } from "react";
import { Eye, MessageCircle, Share2, Users } from "lucide-react";
import { api } from "../lib/api";

export const RANGES = [[7, "7d"], [30, "30d"], [90, "90d"], [0, "All"]];
export const SORTS = [["recent", "Recent"], ["views", "Most views"], ["whatsapp", "Most WhatsApp"], ["wa_rate", "Best WA rate"]];
const EMPTY = { views: 0, visitors: 0, whatsapp: 0, shares: 0, wa_rate: 0 };

export const usePerformance = (days) => {
  const [perf, setPerf] = useState({});
  useEffect(() => { api.get(`/admin/posts/performance?days=${days}`).then(({ data }) => setPerf(data.posts)).catch(() => {}); }, [days]);
  return (slug) => perf[slug] || EMPTY;
};

const Stat = ({ icon: Icon, value, label, testid, hot }) => (
  <span className={`flex items-center gap-1 whitespace-nowrap ${hot ? "text-[#25D366]" : "text-zinc-400"}`} title={label} data-testid={testid}>
    <Icon size={13} /> <span className="font-semibold text-white">{value}</span> <span className="hidden text-[10px] uppercase tracking-wider text-zinc-400 md:inline">{label}</span>
  </span>
);

export const PerfStats = ({ p, slug }) => (
  <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs" data-testid={`perf-${slug}`}>
    <Stat icon={Eye} value={p.views} label="views" testid={`perf-views-${slug}`} />
    <Stat icon={Users} value={p.visitors} label="readers" testid={`perf-visitors-${slug}`} />
    <Stat icon={MessageCircle} value={p.whatsapp} label={`WhatsApp · ${p.wa_rate}%`} testid={`perf-wa-${slug}`} hot={p.whatsapp > 0} />
    <Stat icon={Share2} value={p.shares} label="shares" testid={`perf-shares-${slug}`} />
  </div>
);

export const PerfControls = ({ days, setDays, sort, setSort }) => (
  <div className="mb-4 flex flex-wrap items-center gap-3" data-testid="perf-controls">
    <div className="flex rounded-full border border-[#D4AF37]/30 p-0.5">
      {RANGES.map(([n, l]) => (
        <button key={n} onClick={() => setDays(n)} data-testid={`perf-range-${l.toLowerCase()}`}
          className={`rounded-full px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wider ${days === n ? "bg-[#D4AF37] text-black" : "text-[#D4AF37]"}`}>{l}</button>
      ))}
    </div>
    <select value={sort} onChange={(e) => setSort(e.target.value)} data-testid="perf-sort"
      className="rounded-full border border-[#D4AF37]/30 bg-black/40 px-3 py-1.5 text-xs text-white outline-none">
      {SORTS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
    </select>
  </div>
);
